/**
 * External and off-site links should open in a new tab so the current page stays open.
 */
export function shouldOpenLinkInNewTab(href) {
  if (!href) return false

  const trimmed = href.trim()
  if (!trimmed || trimmed.startsWith('#')) return false
  if (trimmed.startsWith('mailto:') || trimmed.startsWith('tel:')) return false
  if (trimmed.startsWith('/') && !trimmed.startsWith('//')) return false

  if (typeof window === 'undefined') {
    return /^https?:\/\//i.test(trimmed) || trimmed.startsWith('//')
  }

  try {
    const url = new URL(trimmed, window.location.origin)
    return url.origin !== window.location.origin
  } catch {
    return false
  }
}

export function enhanceExternalLinks(root) {
  if (!root) return

  root.querySelectorAll('a[href]').forEach((anchor) => {
    const href = anchor.getAttribute('href') || ''
    if (!shouldOpenLinkInNewTab(href)) return

    anchor.setAttribute('target', '_blank')
    anchor.setAttribute('rel', 'noopener noreferrer')
  })
}
